export class ClonePlanogramRequest{
    planogramId : string = '';
    stateId : string = '';
    storeId : string = '';
    merchId? : number | null = null;
    folderId? : string | null = null;
    name? : string | null = null;
    constructor(planogramId: string, stateId: string, storeId: string, merchId: number | null, folderId: string | null, name: string | null){
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.storeId = storeId;
        this.merchId = merchId;
        this.folderId = folderId;
        this.name = name;
    }
}
